import React from "react";

import { Spin } from "antd";

const CustomLoading = () => {
  return (
    <div className={`loading-fixed`}>
      <div className={`loading-border-radius`}>
        <Spin size={"large"} />
      </div>
    </div>
  );
};

export default CustomLoading;
